module.exports = __webpack_public_path__ + "fonts/roboto-all-400.a91ad097.woff";